export const DotDivider = (props: { className?: string }) => {
  return <span className={props.className}>&#183;</span>;
};

export const VerticalDivider = (props: { className?: string }) => {
  return <span className={props.className}>&#124;</span>;
};
